/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pinned[_ngcontent-%COMP%]{z-index:10;position:-webkit-sticky;position:sticky;top:0}.pin-search-bar[_ngcontent-%COMP%]{margin-left:10px;font-size:14px;color:#00a3e0}"];
export { styles as styles };
